import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/53_card_back_cartoon_hat_cat/53_card_back_cartoon_hat_cat"
 * Contains 1 texture(s)
 */
export class CardsBacks53CardBackCartoonHatCatAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/53_card_back_cartoon_hat_cat/53_card_back_cartoon_hat_cat';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '53_cartoon_hat_cat.png'
    ] as const;
}
